'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwColorPalette = require('./CwColorPalette.scss');

var _CwColorPalette2 = _interopRequireDefault(_CwColorPalette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwColorPalette = function (_React$Component) {
  (0, _inherits3.default)(CwColorPalette, _React$Component);

  function CwColorPalette() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CwColorPalette);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CwColorPalette.__proto__ || (0, _getPrototypeOf2.default)(CwColorPalette)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (color) {
      if (_this.props.onClick) _this.props.onClick(color);
    }, _this.handleMouseDown = function () {
      if (_this.props.onMouseDown) _this.props.onMouseDown(true);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CwColorPalette, [{
    key: 'renderSwatch',
    value: function renderSwatch(color) {
      var _this2 = this;

      return _react2.default.createElement('div', {
        key: color.name,
        'data-cwid': this.props.cwId + '_' + color.id,
        style: { backgroundColor: color.id },
        className: _CwColorPalette2.default.swatch,
        onClick: function onClick() {
          _this2.handleClick(color);
        },
        onMouseDown: this.handleMouseDown
      });
    }
  }, {
    key: 'renderSwatchRow',
    value: function renderSwatchRow(id, swatches) {
      return _react2.default.createElement(
        'div',
        { key: id },
        swatches
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          colors = _props.colors,
          rowLength = _props.rowLength;

      var swatches = [];
      var swatchRows = [];

      // Create grid of swatches
      for (var n = 1; n <= colors.length; n++) {
        swatches.push(this.renderSwatch(colors[n - 1]));
        if (n % rowLength === 0 || n === colors.length) {
          // Add a new row when rowLength reached
          swatchRows.push(this.renderSwatchRow(n, swatches));
          swatches = [];
        }
      }

      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.props.cwId, className: _CwColorPalette2.default.colorPalette, style: this.props.style },
        swatchRows
      );
    }
  }]);
  return CwColorPalette;
}(_react2.default.Component);

CwColorPalette.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Callback function that is fired when dropdown is clicked.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown from derezzing before a selection is registered.
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * Array of colors to be displayed in the color palette. "id" must be equal to the hex of the color. "name" is the text displayed in the trigger field.
   */
  colors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string
  })),
  /**
   * Set of style properties to determine the palette's position. Must contain left and top
   */
  style: _propTypes2.default.shape({
    left: _propTypes2.default.number,
    top: _propTypes2.default.number
  }),
  rowLength: _propTypes2.default.number
};

exports.default = CwColorPalette;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwcolorfield/CwColorPalette.js
// module id = 822
// module chunks = 10